import React, {useEffect, useState} from 'react';
import {GoogleMap, LoadScript, MarkerF} from "@react-google-maps/api";
import api from "../../api";
import {DEFAULT_GUTTER, MAPS_API_KEY} from "../../constants";
import {Button, Col, Modal, Row} from "antd";
import ProfileHeader from "../../Components/ProfileHeader";
import CdnImage from "../../Components/CdnImage";
import {printPrice} from "../../helpers";
import dayjs from "dayjs";
import MarketplaceHeader from "../../Components/MarketplaceHeader";

export default function OfferMap() {

    const [profiles, setProfiles] = useState([]);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [offers, setOffers] = useState([]);

    useEffect(() => {
        api.getPublicProfiles().then(setProfiles)
    }, []);

    function clickMarker(profile) {
        api.getCompanyBySlug(profile.slug).then(setSelectedProfile)
        api.getCompanyOffers(profile.id).then(setOffers)
    }

    const containerStyle = {
        width: '100%',
        height: '90vh',
    };

    const center = {lat: 52.0, lng: 5.0};

    return (
        <>
            <MarketplaceHeader />
            <Modal width={"90%"} footer={null} open={selectedProfile !== null} onCancel={() => {
                setSelectedProfile(null)
                setOffers([])
            }}>
                {selectedProfile && (
                    <>
                        <h1>{selectedProfile.name}</h1>
                        <ProfileHeader company={selectedProfile}/>
                        <h2>Over {selectedProfile.name}</h2>
                        <p>Locatie: {selectedProfile.location}</p>
                        <p>{selectedProfile.description}</p>
                        <Button size={"large"} type={"primary"} href={`/${selectedProfile.slug}`} className={"mar-b-1"}>
                            Bekijk profiel
                        </Button>
                        <h1>Aanbod</h1>
                        {offers.length > 0 ? (
                            <Row gutter={DEFAULT_GUTTER}>
                                {offers.map((offer, i) => (
                                    <Col key={i} xs={24} sm={12} md={8} lg={6}>

                                        <h2>{offer.title}</h2>
                                        <div className={"mar-b-1"}>
                                            <CdnImage src={offer.image} width={500} height={250}/>
                                        </div>
                                        <h3>{printPrice(offer.price)} {offer.unit}</h3>
                                        <p>Verkoop start <b>{dayjs(offer.start_at).fromNow()}</b></p>
                                        <p>Verkoop stopt <b>{dayjs(offer.end_at).fromNow()}</b></p>
                                    </Col>
                                ))}
                            </Row>
                        ) : (
                            <p>Er zijn momenteel geen aanbiedingen van deze tuin.</p>
                        )}

                    </>
                )}
            </Modal>
            {(profiles.length > 0) && (
                <>
                    <LoadScript googleMapsApiKey={MAPS_API_KEY}>
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={8}
                        >
                            {profiles.filter((profile) => {
                                return profile.lat && profile.lng && profile.offers.length > 0
                            }).map((profile, i) => (
                                <MarkerF
                                    key={`marker${i}`}
                                    position={{lat: profile.lat, lng: profile.lng}}
                                    title={profile.name}
                                    onClick={() => {
                                        // Handle marker click if needed
                                        clickMarker(profile)
                                    }}
                                />
                            ))}
                        </GoogleMap>
                    </LoadScript>
                </>
            )}
        </>
    );

}